import { HomepageHeroProps } from '../types';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import RichTextList from 'components/shared/RichTextList/RichTextList';
import { BulletListStyle } from 'types/constants';

interface HomepageHeroListProps extends Pick<HomepageHeroProps, 'sys' | 'copy'> {
  listDisplay?: 'inline' | 'block';
}

const HomepageHeroList = ({ sys, copy, listDisplay }: HomepageHeroListProps) => {
  return (
    <div
      className="font-sans font-medium leading-[1.4] mx-auto max-sm:w-full text-(--hero-accent-text) [&_li]:my-1"
      {...liveUpdateAttrs(sys?.id, 'copy')}>
      {copy && (
        <RichTextList
          item={copy}
          bulletListStyle={BulletListStyle.Checkmark}
          arrowStyles="in-cw-action-primary:[&_path]:!stroke-white"
          listDisplay={listDisplay}
        />
      )}
    </div>
  );
};

export default HomepageHeroList;
